var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link",attrs:{"href":_vm.url}},[_vm._t("default",function(){return [_vm._v("默认内容")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }